import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Checkbox from 'components/Checkbox'

const CheckboxWithLabel = ({ label, onChange, checked, className, type = 'checkbox', ...rest }) => {
  const handleChange = (event) => {
    event.persist()
    onChange(event.target.checked, event)
  }

  return (
    <label
      className={cn(['checkbox-with-label', className], {
        '-checked': checked,
        '-switcher': type === 'switcher',
        '-checkbox': type === 'checkbox',
      })}
    >
      {label}
      <Checkbox
        checked={checked}
        className="checkbox-with-label__input"
        onChange={handleChange}
        {...rest}
      />
      <div className="checkbox-with-label__checkbox" />
    </label>
  )
}

CheckboxWithLabel.defaultProps = {
  onChange: () => {},
}

CheckboxWithLabel.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['checkbox', 'switcher']),
}

export default CheckboxWithLabel
